import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import BasicMenu from "../../helpers/menu";
import a11yProps from "../../helpers/ay-props";
import EditIcon from "@mui/icons-material/Edit";
import { connect } from "react-redux";
import {
  Tooltip,
  Chip,
  IconButton,
  Tabs,
  Tab
} from "@mui/material";
import moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import { MdEditNotifications } from "react-icons/md";

const statuses = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Departed",
    value: "quit",
  },
];

function StaffPositionComponent({ FetchDetails, structures, wholeStructure, systemSettings }) {
  const mainBackground = systemSettings?.mainBackground;
  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [positions, setPositions] = React.useState([]);
  const [statusTab, setStatusTab] = React.useState(0); // Default to "Active" tab
  const location = useLocation(); // Get the state passed from EmployeesManagement
  const history = useHistory(); // Initialize useHistory
  const [period, setPeriod] = React.useState({
    startDate: null,
    endDate: null,
  });
  const [selectedPosition, setSelectedPosition] = React.useState("");
  const [selectedContractType, setSelectedContractType] = React.useState("");

  const [structurePath, setStructurePath] = React.useState([]);
  const [selectedStructure, setSelectedStructure] = React.useState();

  const getChildren = (parent, allStructures) => {
    const parentId = parent?.id || null;
    return allStructures.filter(s => s.parentId === parentId);
  };
  const institutionOptions = getChildren(null, wholeStructure);
  const [openStatus, setOpenStatus] = React.useState(0);

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  const handleStatusTabChange = (event, newValue) => {
    setStatusTab(newValue);
  };

  const columns = [
    {
      name: "names",
      label: "Names",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "phone",
      label: "Phone No",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "positionName",
      label: "Position",
    },
    {
      name: "structureName",
      label: "Structure",
    },
    {
      name: "projectsAssigned",
      label: "Projects Assigned",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (v) => {
          return (
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    boxShadow:
                      "3px 4px 6px rgba(0, 0, 0, 0.1), 2px 2px 4px rgba(0, 0, 0, 0.06)",
                    color: "black",
                  },
                },
              }}
              title={`${v} Project${v > 1 ? "s" : ""}`}
            >
              <Chip size={"small"} label={v} />
            </Tooltip>
          );
        },
      },
    },
    {
      name: "id",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => {
          const obj = list.find((vx) => vx.id === v);
          const request = obj?.Requests?.length > 0 ? obj?.Requests[0] : null;

          const status = obj?.status;

          return (
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    boxShadow:
                      "3px 4px 6px rgba(0, 0, 0, 0.1), 2px 2px 4px rgba(0, 0, 0, 0.06)",
                    color: "black",
                  },
                },
              }}
              title={
                request &&
                request?.status === "approved" &&
                moment(request?.endDate).isAfter(new Date()) && (
                  <div className="flex flex-wrap p-2 bg-white h-42">
                    <div className="flex flex-col">
                      <div className="flex gap-2">
                        <span className="font-semibold">Start Date:</span>
                        <span>
                          {moment(request?.startDate).format("YYYY-MMM-DD")}
                        </span>
                      </div>
                      <div className="flex gap-2">
                        <span className="font-semibold">Return Date:</span>
                        <span>
                          {moment(request?.endDate).format("YYYY-MMM-DD")}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              }
            >
              {(request &&
                request?.status === "approved" &&
                moment(request?.endDate).isAfter(new Date())) ||
                obj?.status === "on-leave" ||
                obj?.status === "on leave" ? (
                <Chip
                  sx={{ backgroundColor: "#FFA400", color: "white" }}
                  label={"on leave"}
                />
              ) : (
                <Chip
                  sx={{
                    backgroundColor:
                      status === "completed" ||
                        status === "active" ||
                        status === "paid"
                        ? "green"
                        : status === "canceled" ||
                          status === "overdue" ||
                          status === "deleted" ||
                          status === "quit" ||
                          status === "denied" ||
                          "departed"
                          ? "#8B0000"
                          : status === "not yet started" ||
                            status === "in progress" ||
                            status === "in-progress"
                            ? "#FFA400"
                            : status === "to-do"
                              ? "#3895D3"
                              : status === "incoming" || status === "upcoming"
                                ? "#ADD8E6"
                                : status === "on-leave"
                                  ? "#FFA400"
                                  : "",
                    color:
                      status === "completed" ||
                        status === "active" ||
                        status === "paid"
                        ? "white"
                        : status === "canceled" ||
                          status === "overdue" ||
                          status === "deleted" ||
                          status === "quit" ||
                          status === "denied" ||
                          "departed"
                          ? "white"
                          : status === "not yet started" ||
                            status === "in progress" ||
                            status === "in-progress"
                            ? "white"
                            : status === "to-do"
                              ? "white"
                              : status === "on-leave"
                                ? "white"
                                : "",
                  }}
                  label={obj?.status === "quit" ? "Departed" : obj?.status}
                />
              )}
            </Tooltip>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (

          <BasicMenu
            extra={[
              {
                label: "Change Status",
                onClick: () => {
                  setOpenStatus(1);
                  const obj = list.find((vx) => vx.id === v);
                  setValue0("status", obj.status);
                  setId(v);
                },
              },
              {
                label: "Edit",
                // icon: (
                //   <img
                //     src={require("../../assets/icons/pencil.svg").default}
                //     alt="Edit"
                //     style={{ width: 18, height: 18, marginRight: 8 }}
                //   />
                // ),
                icon: (
                  <EditIcon fontSize="small" className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall css-ptiqhd-MuiSvgIcon-root" />
                ),
                onClick: (e) => {

                  // e.stopPropagation();
                  setOpen(2);
                  const obj = list.find(vx => vx.id === v);
                  // console.log(obj);
                  setId(v);
                  const firstName = obj.names.split(" ")[0];
                  const surname = obj.names.split(" ").slice(1).join(" ");
                  setValue0('firstName', firstName);
                  setValue0('surname', surname);
                  setValue0('email', obj.email);
                  setValue0('phone', obj.phone);
                  setValue0('entryDate', obj.entryDate || moment().format("YYYY-MM-DD"));
                  setValue0('positionId', obj.positionId);
                  setValue0('structureId', obj.structureId);
                  setStructurePath([{ id: obj.Institution?.id, name: obj.Institution?.institutionName, category: "Institution", children: obj.Institution?.children || [] }]);
                  setSelectedStructure({ id: obj.Institution?.id, name: obj.Institution?.institutionName, category: "Institution", children: obj.Institution?.children || [] });
                  setValue0('structureId', obj.structureId);
                  setSelectedPosition(obj.positionId);
                }
              },
            ]}
          />

        ),
      },
    },
  ];
  const loadPositions = async () => {
    const resp = await FetchDetails(`/api/staff-position/viewAll`);
    if (resp?.status) {
      const positionList = resp?.data?.list?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setPositions(positionList);
    }
  };
  const onSuccess = () => setCount((v) => v + 1);
  useEffect(() => {
    loadPositions().then();
  }, []);

  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/staff-position/delete/${id}`}
      />
      <FormDialog
        maxWidth={"md"}
        open={open > 0}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={open === 1 ? "/api/resource/create/cichiin-emp" : `/api/resource/update/cichiin-emp/${id}`}
        title={open === 1 ? "Create New Employee" : "Edit Employee"}
        fields={[
          {
            name: "firstName",
            label: "First Name",
            type: "text",
            value: value["firstName"],
            required: true,
            setValue: (val) => setValue0("firstName", val),
          },
          {
            name: "surname",
            label: "Last Name",
            type: "text",
            value: value["surname"],
            required: true,
            setValue: (val) => setValue0("surname", val),
          },
          {
            name: "email",
            label: "Email",
            type: "email",
            value: value["email"],
            required: true,
            setValue: (val) => setValue0("email", val),
          },

          {
            name: "positionId",
            label: "Position",
            type: "select",
            values: positions,
            value: value["positionId"],
            // required: true,
            setValue: (val) => setValue0("positionId", val),
          },
          {
            name: "entryDate",
            label: "Entry Date",
            type: "date",
            value: value["entryDate"] || moment().format("YYYY-MM-DD"),
            required: true,
            setValue: (val) => setValue0("entryDate", val),
          },
          {
            name: "institution",
            label: "Institution",
            type: "select",
            values: institutionOptions.map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[0]?.id || "",
            required: true,
            setValue: (val) => {
              const selected = institutionOptions.find(opt => opt.id === val);
              const newPath = selected ? [selected] : [];
              setStructurePath(newPath);
              setSelectedStructure(selected);
              setValue0("structureId", selected?.id || "");
            }
          },
          ...(structurePath[0]?.children?.length > 0 ? [{
            name: "office",
            label: "Office",
            type: "select",
            values: (structurePath[0]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[1]?.id || "",
            required: false,
            setValue: (val) => {
              const selected = structurePath[0]?.children?.find(opt => opt.id === val);
              const newPath = selected ? [structurePath[0], selected] : [structurePath[0]];
              setStructurePath(newPath);
              setSelectedStructure(selected || structurePath[0]);
              setValue0("structureId", selected ? selected.id : structurePath[0].id);
            }
          }] : []),
          ...(structurePath[1]?.children?.length > 0 ? [{
            name: "dipartment",
            label: structurePath[2]?.category || "Department",
            type: "select",
            values: (structurePath[1]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[2]?.id || "",
            required: false,
            setValue: (val) => {
              const selected = structurePath[1]?.children?.find(opt => opt.id === val);
              const newPath = selected ? [structurePath[0], structurePath[1], selected] : [structurePath[0], structurePath[1]];
              setStructurePath(newPath);
              setSelectedStructure(selected || structurePath[1]);
              setValue0("structureId", selected ? selected.id : structurePath[1].id);
            }
          }] : []),
          ...(structurePath[2]?.children?.length > 0 ? [{
            name: "division",
            label: structurePath[3]?.category || "Unit",
            type: "select",
            values: (structurePath[2]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
            value: structurePath[3]?.id || "",
            required: false,
            setValue: (val) => {
              const selected = structurePath[2]?.children?.find(opt => opt.id === val);
              const newPath = selected ? [...structurePath.slice(0, 3), selected] : structurePath.slice(0, 3);
              setStructurePath(newPath);
              setSelectedStructure(selected || structurePath[2]);
              setValue0("structureId", selected ? selected.id : structurePath[2].id);
            }
          }] : []),
          {
            name: "phone",
            label: "Contact Number",
            type: "text",
            value: value["phone"],
            setValue: (val) => setValue0("phone", val),
          },

        ]}
      />
      <FormDialog
        maxWidth={"sm"}
        open={openStatus > 0}
        onSuccess={onSuccess}
        setOpen={setOpenStatus}
        url={`/api/resource/change/status/${id}`}
        title={"Change Status"}
        fields={[
          {
            name: "status",
            label: "Status",
            type: "select",
            values: statuses,
            value: value["status"],
            required: true,
            setValue: (val) => setValue0("status", val),
          },
        ]}
      />
      <DatatableComponent
        viewColumns={false}
        searchfield={true}
        search={false}
        hideToolbar={false}
        onRowClick={(data, { rowIndex }) => {
          history.push(`/admin/profile/${list[rowIndex].id}`);
        }}


        // {...statusTab === 0 ? { count: count, status: "active" } : { count: count, status: "quit" }}
        {...(statusTab === 0 && {
          onAddNew: () => {
            setOpen(1);
            // console.log("Selected Status: ", statuses);
          }
        })}


        processData={(data) => {
          const processedData = data.data.map((item) => {
            const division = item.Division?.name;
            const department = item.Department?.name;
            const office = item.Office?.name;
            const institution = item.Institution?.institutionName;

            item.Structure =
              division || department || office || institution || " ";
            return item;
          });

          setList(processedData);
          return { ...data, data: processedData };
        }}
        elevation={1}
        columns={columns}
        url={`/api/resource/list?count=${count}&status=${statusTab === 0 ? "active" : "quit"
          }&assigned=${location.state?.assigned ?? ""}&category=${location.state?.category ?? ""
          }&year=${location.state?.year ?? ""}&startDate=${period.startDate
          }&endDate=${period.endDate
          }&positionId=${selectedPosition}&type=${selectedContractType}`}
        // title={
        //   "Employee List"
        // }
        title={
          <div className="flex items-center justify-between">
            {/* Left: Active and Departed Tabs */}
            <Tabs
              value={statusTab}
              onChange={handleStatusTabChange}
              aria-label="status tabs"
              TabIndicatorProps={{
                style: {
                  borderRadius: "10px",
                  backgroundColor: mainBackground,
                },
              }}
            >
              <Tab
                label="Active"
                style={{
                  marginLeft: "10px",
                  marginBottom: "10px",
                  marginTop: "10px",
                  borderRadius: "10px",
                  backgroundColor:
                    statusTab === 0 ? mainBackground : "transparent",
                  color: statusTab === 0 ? "white" : "black",
                }}
                {...a11yProps(0)}
              />
              <Tab
                label="Departed"
                style={{
                  marginLeft: "10px",
                  marginBottom: "10px",
                  marginTop: "10px",
                  borderRadius: "10px",
                  backgroundColor:
                    statusTab === 1 ? mainBackground : "transparent",
                  color: statusTab === 1 ? "white" : "black",
                }}
                {...a11yProps(1)}
              />
            </Tabs>
          </div>
        }
      />
    </div>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffPositionComponent);
